export default {
    name: 'OfflineInspectionMessage',

    functional: true,

    render(h, { parent }) {
        return h('div', {
            class: 'item',
        }, [
            h('h4', parent.$t('You are offline!')),
            h('p', parent.$t('Please note that while you were offline you might have reached the inspections limit for this month.')),
            h('p', parent.$t('You might not be able to submit the conducted inspection until the start of next period.')),
        ]);
    },
};
